var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmarkselected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66602 6.33301H19.666V20.333L13.666 16.833L7.66602 20.333V6.33301Z",
    fill: "#797AF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83333 6H19.5C19.721 6 19.933 6.08081 20.0893 6.22464C20.2455 6.36848 20.3333 6.56357 20.3333 6.76698V21.4494C20.3334 21.5179 20.3135 21.5853 20.2757 21.6444C20.238 21.7035 20.1836 21.7522 20.1185 21.7854C20.0533 21.8186 19.9796 21.8351 19.9051 21.8332C19.8306 21.8313 19.7581 21.811 19.695 21.7746L13.6667 18.2948L7.63833 21.7738C7.57531 21.8102 7.50282 21.8305 7.42842 21.8324C7.35401 21.8343 7.28041 21.8179 7.21525 21.7848C7.15009 21.7517 7.09576 21.7031 7.0579 21.6441C7.02005 21.5851 7.00006 21.5179 7 21.4494V6.76698C7 6.56357 7.0878 6.36848 7.24408 6.22464C7.40036 6.08081 7.61232 6 7.83333 6ZM18.6667 7.53397H8.66667V19.3701L13.6667 16.4854L18.6667 19.3701V7.53397Z",
    fill: "#797AF2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkselected);
export default __webpack_public_path__ + "static/media/bookmarkselected.e5e3c3e32c24d5f076d96a7a358bcef5.svg";
export { ForwardRef as ReactComponent };